export const scrollToContactSection = () => {
  const element = document.getElementById('contact-us');
  if (element) {
    const headerOffset = 100;
    const elementPosition = element.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = elementPosition - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
}

export const setCookie = (name: string, value: string, days = 365): void => {
  if (typeof document === 'undefined') return; // Prevent running on server

  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = "; expires=" + date.toUTCString();
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; path=/; secure; sameSite=Lax`;
}

export const getLangFromCookies = (cookieHeader?: string): string | undefined => {
  if (!cookieHeader) return undefined;
  const cookies = Object.fromEntries(
    cookieHeader.split(';').map(c => {
      const [k, v] = c.trim().split('=');
      return [k, decodeURIComponent(v)];
    })
  );
  return cookies['appLang'];
}
